import * as React from 'react'
import { SVGUniqueID } from 'react-svg-unique-id'

interface InfoCircleIconProps {
  width?: number
  height?: number
}

const InfoCircleIcon: React.FC<InfoCircleIconProps> = ({
  width = 24,
  height = 24,
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="info-circle" clipPath="url(#clip0_236_901)">
        <path
          id="Icon"
          d="M10.0001 13.3333V9.99996M10.0001 6.66663H10.0084M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663C14.6025 1.66663 18.3334 5.39759 18.3334 9.99996Z"
          stroke="black"
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_236_901">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
)

export { InfoCircleIcon }
